/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="my-return-edit with-loader-absolute">
    <div class="account-content">
      <div class="account-content__body">
        <div class="progress-last">
          <b-row no-gutters>
            <b-col sm="6">
              <div class="wrapper-box">
                <p>{{$t('returns.edit.progress.box-1')}}</p>
              </div>
            </b-col>
            <b-col sm="6">
              <div class="wrapper-box">
                <p>{{$t('returns.edit.progress.box-2')}}</p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="order-info-detail">
          <p class="info-title">{{$t('returns.edit.info.title')}}</p>
          <div class="intro-request">
            <p class="text-uppercase">{{$t('returns.edit.info.rma-id')}}: <span>#{{rmaDetail.id}}</span></p>
            <p>{{$t('returns.edit.info.created-at')}}: <span>{{createdAt}}</span></p>
            <p class="text-capitalize">{{$t('returns.edit.info.order')}}:
              <span v-for="order in rmaDetail.orders" :key="order.id">#{{order.order_number}}</span>
            </p>
          </div>
        </div>
        <template v-for="(order, index) in rmaDetail.orders">
          <table-layout
          class="return-edit-table"
          :items="order.items"
          :key="index"
          :fields="fields"
          :tileComponent="tableTileComponent" />
          <!-- <DetailRmaListProduct :orders="rmaDetail.orders"/> -->
        </template>
        <!-- add message -->
        <b-row>
          <b-col md="6">
            <add-message :reply.sync="reply" :files.sync="filesMessage" :rmaId="rmaDetail.guest_id" @saved="messageUpdated"/>
          </b-col>
          <b-col md="6">
            <list-message :messages="rmaDetail.messages"/>
          </b-col>
        </b-row>
      </div>
    </div>
    <absolute-loader :showLoader="rmaCall" mode="fixed"></absolute-loader>
  </section>
</template>

<script>
import dayjs from 'dayjs'
import Rma from '@/services/Rma'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import DetailRmaListProduct from 'theme/components/MyAccount/Rma/DetailRmaListProduct'
import TableLayout from 'theme/components/Tables/TableLayout'
import ListItemEditTile from 'theme/components/Tables/Tiles/ListItemEditTile'
import AddMessage from 'theme/components/MyAccount/Rma/AddMessage'
import ListMessage from 'theme/components/MyAccount/Rma/ListMessage'

export default {
  data () {
    return {
      rmaCall: false,
      tableTileComponent: ListItemEditTile,
      rmaDetail: {},
      reply: '',
      filesMessage: [],
      fields: [
        {
          key: 'product',
          label: this.$t('returns.edit.table.header.product-name')
        },
        {
          key: '',
          label: ''
        },
        {
          key: 'motivation',
          label: this.$t('returns.edit.table.header.motivation')
        },
        {
          key: 'request-type',
          label: this.$t('returns.edit.table.header.request-type')
        },
        {
          key: 'motivation-detail',
          label: this.$t('returns.edit.table.header.motivation-detail')
        },
        {
          key: 'qty',
          label: this.$t('returns.edit.table.header.qty')
        },
        {
          key: 'subtotal',
          label: this.$t('returns.edit.table.header.subtotal')
        }
      ]
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user.current
    },
    createdAt () {
      if (Object.keys(this.rmaDetail).length) {
        return dayjs(this.rmaDetail.created_at).format(this.$t('dateFormat'))
      }
      return null
    }
  },
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', 'returns.edit.title')
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const _this = this
      this.rmaCall = true
      Rma.detail({
        storeViewCode: this.$store.state.ui.storeViewCode,
        variables: {
          id: this.$route.params.id
        }
      }).then(rmaDetail => {
        _this.rmaDetail = rmaDetail
        _this.rmaCall = false
      })
    },
    messageUpdated () {
      this.init()
    }
  },
  components: {
    AbsoluteLoader,
    DetailRmaListProduct,
    AddMessage,
    ListMessage,
    TableLayout
  }
}
</script>
